import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabloSmartCropComponent } from '@ui/tablo-generator/tablo-studio/tablo-smart-crop/tablo-smart-crop.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [TabloSmartCropComponent],
  exports: [TabloSmartCropComponent],
  imports: [CommonModule, FormsModule],
})
export class TabloSmartCropModuleModule {}
